export default __webpack_public_path__ + "static/media/8.2.80a4b393.jpeg";